import { connect } from 'react-redux';
import GenericLoader, { buildLoader } from '../util/GenericLoader';
import {
  getDeploymentsAction,
  getDeploymentConfigAction,
  getDeploymentModbusAction,
  getDeploymentDiscoveryAction,
  getHeartbeatsAction,
} from '../../redux/actions/deployments';

export const DeploymentsLoader = buildLoader(getDeploymentsAction);

export const HeartbeatsLoader = connect(null, (dispatch, { site }) => ({
  fetchFunction: () => {
    dispatch(getHeartbeatsAction(site));
  },
}))(GenericLoader);

export const DeploymentConfigLoader = connect(null, (dispatch, { site }) => ({
  fetchFunction: () => {
    dispatch(getDeploymentConfigAction(site));
  },
}))(GenericLoader);

export const DeploymentModbusLoader = connect(null, (dispatch, { site }) => ({
  fetchFunction: () => {
    dispatch(getDeploymentModbusAction(site));
  },
}))(GenericLoader);

export const DeploymentDiscoveryLoader = connect(null, (dispatch, { site }) => ({
  fetchFunction: () => {
    dispatch(getDeploymentDiscoveryAction(site));
  },
}))(GenericLoader);
